export const API_URL = "https://production-eth2-sov1-api.ethereum.fish"
